export const CARGAR_FACTURAS_FECHA = 'CARGAR_FACTURAS_FECHA';
export const CARGAR_DEVOLUCIONES_FECHA = 'CARGAR_DEVOLUCIONES_FECHA';
export const CARGAR_DESCUENTOS_FECHA = 'CARGAR_DESCUENTOS_FECHA';
export const CARGAR_PROFORMAS_FECHA = 'CARGAR_PROFORMAS_FECHA';
export const CARGAR_PEDIDO_PROCESO_FECHA = 'CARGAR_PEDIDO_PROCESO_FECHA';
export const CARGAR_ARTICULOS_FECHA = 'CARGAR_ARTICULOS_FECHA';